var StreamUseCase = /** @class */ (function () {
    function StreamUseCase(streamRepo) {
        this.streamRepo = streamRepo;
    }
    StreamUseCase.prototype.streamQuote = function (streaming_type, subscribe, callBack, symbols, streamKey, sectionName) {
        this.streamRepo.streamQuote(streaming_type, subscribe, callBack, symbols, streamKey, sectionName);
    };
    StreamUseCase.prototype.activeScreen = function (active) {
        this.streamRepo.activeScreen(active);
    };
    return StreamUseCase;
}());
export default StreamUseCase;
